const interfacePhrases = {
    rate_limited: 'İstek sıklığı sınırlı',
    limit_exceeded: 'Sınır aşıldı',
    used: 'Kullanım',
    identifier: 'Tanımlayıcı',
    verification: 'Doğrulama',
    messages: 'Mesajlar',
    data: 'Veriler',
    custom: 'Özel',
    management_api: '{{product}} Yönetim API’si',
    management_api_role_description: 'Bu yerleşik rol, yönetim API’sine erişim sağlar.',
    client_credentials: 'İstemci kimlik bilgileri',
    authentication_request: 'Kimlik doğrulama isteği',
    callback: 'Kimlik doğrulama geri çağrısı',
    help_title: 'iden Yardım Merkezi',
    help_subtitle: 'Çalışma alanınızdan ayrılmadan yardım alın',
    open_help: 'Tam yardım sayfasını aç',
    close_help: 'Yardımı kapat',
    about: 'Hakkında ve açık kaynak',
    open_navigation: 'Gezinmeyi aç',
    close_navigation: 'Gezinmeyi kapat',
    development_enabled: 'Geliştirme özellikleri etkin',
    beta: 'Beta',
    impersonation: 'Kullanıcı kimliğine bürünme',
    key: 'Anahtar',
    value: 'Değer',
    error: 'Hata',
    details: 'Teknik ayrıntılar',
    callback_failed: 'Oturum açma geri çağrısı tamamlanamadı.',
    back_sign_in: 'Oturum açmaya dön',
    powered_by: 'Altyapı sağlayıcısı',
    avatar: 'Avatar',
    logo: 'Logo',
    qr_code: 'QR kodu',
    sample_title: 'Bir örnek görmek ister misiniz?',
    sample_description: 'Bu kılavuzu kullanan örnek bir uygulamayı keşfedin.',
    sample_action: 'Örneği görüntüle',
    further_readings: 'Ek kaynaklar',
    complete_guide: 'Tam kılavuz',
    custom_domains_notice: '<a>Özel alan adları</a> ekledikten sonra şu uç noktayı kullanabilirsiniz: <code>{{endpoint}}</code>.',
    my_project: 'Projem',
    my_secret: 'Gizli anahtarım',
    my_token: 'Belirtecim',
    role_example: 'Okuyucu',
    reset_retry: 'Yapılandırmayı sıfırla ve yeniden dene',
    open_dev_panel: 'Geliştirici panelini aç',
    close_dev_panel: 'Geliştirici panelini kapat',
    configuration: 'Yapılandırma',
    app_id: 'Uygulama kimliği',
    extra_parameters: 'Ek oturum açma parametreleri',
    prompt: 'Kimlik doğrulama istemi',
    scope: 'Kapsam',
    resource: 'Kaynak',
    resources_space_delimited: 'Kaynaklar (boşlukla ayrılmış)',
    sign_out_to_apply: 'Değişiklikleri uygulamak için oturumu kapatın.',
    refresh_token_grant: 'Yenileme belirteci yetkilendirmesi',
    organization_id: 'Kuruluş kimliği',
    console_result: 'Sonucu tarayıcı konsolunda görebilirsiniz.',
    request_token: 'Belirteç iste',
    user_info: 'Kullanıcı bilgileri',
    get_id_token_claims: 'Kimlik belirteci taleplerini al',
    fetch_user_info: 'Kullanıcı bilgilerini getir',
    device_initializing: 'Cihaz yetkilendirmesi başlatılıyor…',
    device_success: 'Demo uygulamasında oturum açtınız.',
    sign_in_information: 'Oturum açma bilgileriniz:',
    email: 'E-posta',
    username: 'Kullanıcı adı',
    user_id: 'Kullanıcı kimliği',
    sign_out_demo: 'Demodan çıkış yap',
    device_expired: 'Cihaz kodunun süresi doldu',
    generic_error: 'Bir sorun oluştu',
    device_expired_description: 'Cihaz kodunun süresi doldu. Yeni bir kod almak için yeniden deneyin.',
    sign_in_title: 'Hesabınızda oturum açın',
    scan_instruction: 'QR kodunu tarayın veya bu adresi başka bir cihazda açın:',
    one_time_code: 'Tek kullanımlık kodu girin',
    token_info: 'Belirteç bilgileri',
    get_access_token: 'Erişim belirteci al',
    context_unavailable: 'Hesap bilgileri yüklenemedi.',
    not_initialized: 'Hesap bilgileri başlatılmadı.',
    not_set: 'Ayarlanmamış',
    configured: 'Yapılandırılmış',
    password: 'Parola',
    phone: 'Telefon numarası',
    search_help: 'Yardımda ara',
    language: 'Dil',
    menu: 'Menü',
    compatibility_notice: 'Uyumluluk notu: Devralınan Logto SDK, paket, protokol, bileşen ve istek başlığı adları değişmeden kalır.',
    source: 'Kaynak',
    upstream_repository: 'Üst kaynak deposu',
    current_fork: 'Geçerli depo',
    license_notice: 'iden, Mozilla Public License 2.0 ile lisanslanan açık kaynaklı Logto yazılımına dayanmaktadır.',
    about_description: 'Ürün bilgileri ve açık kaynak atıfları.',
    page_not_found: 'Sayfa bulunamadı',
    page_not_found_description: 'Bu sayfa kullanılamıyor. Devam etmek için yardım merkezine dönün.',
    introduction: 'Giriş',
    quick_starts: 'Hızlı başlangıç',
    integration: 'Entegrasyon',
    end_user_flows: 'Son kullanıcı akışları',
    authorization: 'Yetkilendirme',
    user_management: 'Kullanıcı yönetimi',
    security: 'Güvenlik',
    customization: 'Özelleştirme',
    connectors: 'Bağlayıcılar',
    organizations: 'Kuruluşlar',
    self_hosting: 'Kendi sunucunda barındırma',
    continue: 'Devam et',
    loading: 'Yükleniyor…',
    save: 'Kaydet',
    saved: 'Kaydedildi',
    try_again: 'Yeniden dene',
    client_id: 'İstemci kimliği',
    client_secret: 'İstemci gizli anahtarı',
    redirect_uri: 'Yönlendirme URI’si',
    status: 'Durum',
    type: 'Tür',
    permissions: 'İzinler',
    token_data: 'Belirteç verileri',
    context_data: 'Bağlam verileri',
    jwt_extra_claims: 'Ek belirteç talepleri',
    action_result: 'İşlem sonucu',
    social_account_already_linked: 'Bu sosyal hesap zaten bağlı.',
};
export default Object.freeze(interfacePhrases);
